import { createContext, useContext, ReactNode } from 'react';
import { useWorkplaceDetails } from '@/hooks/business/useWorkplaceDetails';
import { useAuth } from '@/hooks/useAuth';

interface WorkplaceCurrencyContextValue {
  currencyCode: string;
  isLoading: boolean;
}

const WorkplaceCurrencyContext = createContext<WorkplaceCurrencyContextValue | undefined>(undefined);

export function WorkplaceCurrencyProvider({ children }: { children: ReactNode }) {
  const { user, profile, currentCompany } = useAuth();
  const hasCompanyAssociation = !!(user && profile && currentCompany);
  
  const { data: workplaceDetails, isLoading } = useWorkplaceDetails({ 
    enabled: hasCompanyAssociation 
  });
  
  const currencyCode = workplaceDetails?.currency_code || 'USD';

  return (
    <WorkplaceCurrencyContext.Provider value={{ currencyCode, isLoading }}>
      {children}
    </WorkplaceCurrencyContext.Provider>
  );
}

export function useWorkplaceCurrency() {
  const context = useContext(WorkplaceCurrencyContext);
  if (context === undefined) {
    throw new Error('useWorkplaceCurrency must be used within a WorkplaceCurrencyProvider');
  }
  return context;
}